export default "__VITE_ASSET__BTpZ4bb9__"